<template>
  <div @click="createIframe" class="wrapper">
    <div class="imgs">
      <img
        v-for="(item, index) in imgs"
        :key="index"
        :src="item"
        @click="openDownload"
      />
    </div>
    <div v-if="showGuide" class="guide">
      <img src="https://image.hzwxbz2.cn/java-yunying/jyy_1725266642124_8f6a1d951e1374e59666a8b22f037754.png" />
    </div>
    <ActivityPopup
      :visible.sync="visible"
      v-bind="feedback"
      showCancelButton
      @confirm="feedback.onSure"
      @cancel="feedback.onCancel"
    >
    </ActivityPopup>
  </div>
</template>

<script>
import JumpMain from './jump'
import { checkIsWxBrowser } from '@/libs/utils'
import { getBoxDownloadInfo } from '@/apis/box'
export default {
  name: 'CustomJumpToHezi',
  mixins: [JumpMain],
  data () {
    return {
      showGuide: false,
      imgs: [],
    }
  },
  mounted () {
    this.handleFetchInfo()
    if (!checkIsWxBrowser()) {
      this.init()
    } else {
      this.showGuide = true
    }
  },

  computed: {
    planId () {
      return this.$route.query.id
    },
  },
  methods: {
    handleFetchInfo () {
      getBoxDownloadInfo({
        type: this.curApp.type
      }).then(res => {
        const { pictureUrl } = res.data
        this.imgs = [pictureUrl]
      })
    },
    handleDownload () {
      console.log('open-->', this.curApp.downloadUrl)
      window.location.href = `http://pop.ad.wxbz123.cn/Planlist/ad?id=${this.planId}`
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100vw;
  min-height: 100vh;
}
.imgs {
  padding: 0;
  height: fit-content;
  font-size: 0;
  img {
    width: 100%;
  }
}
.guide {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100vh;
  // background-color: #333333af;
  img {
    width: 100%;
  }
}
</style>
